import { useState, useEffect } from 'react';

/**
 * Returns true when the viewport width is at or above `breakpoint` (default 1024px).
 * Used to swap the mobile HomeScreen for the full-width DesktopHomeScreen.
 */
export default function useIsDesktop(breakpoint = 1024) {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' && window.innerWidth >= breakpoint
  );

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= breakpoint);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isDesktop;
}
